module.exports = __webpack_public_path__ + "img/cantidad_empleos.de15619f.jpeg";